import clsx from 'clsx';
import Button from '../../../components/Button';
import Card from '../../../components/Card';
import { ExchangeTradeTypes } from '../../../context/trade/tradeTypes';
import useTradeState from '../../../context/trade/useTradeState';
import ExchangeLimit from './ExchangeLimit';
import ExchangeMarket from './ExchangeMarket';
import ExchangeStopLimit from './ExchangeStopLimit';
import ExchangeStopMarket from './ExchangeStopMarket';
import ExchangeTakeProfitLimit from './ExchangeTakeProfitLimit';
import ExchangeTakeProfitMarket from './ExchangeTakeProfitMarket';
import ExchangeTrailingStop from './ExchangeTrailingStop';

const renderTabs = {
    [ExchangeTradeTypes.MARKET]: <ExchangeMarket />,
    [ExchangeTradeTypes.LIMIT]: <ExchangeLimit />,
    [ExchangeTradeTypes.STOP_LIMIT]: <ExchangeStopLimit />,
    [ExchangeTradeTypes.STOP_MARKET]: <ExchangeStopMarket />,
    [ExchangeTradeTypes.TRAILING_STOP]: <ExchangeTrailingStop />,
    [ExchangeTradeTypes.TAKE_PROFIT_LIMIT]: <ExchangeTakeProfitLimit />,
    [ExchangeTradeTypes.TAKE_PROFIT_MARKET]: <ExchangeTakeProfitMarket />,
};

const ExchangeSwap = () => {
    const { tradeType, setTradeType, toggleIsShort, isShort } = useTradeState();

    return (
        <div className='exchange-swap'>
            <Card>
                <div className='is-short-button-container'>
                    <Button
                        onClick={toggleIsShort}
                        className={clsx('long', { active: !isShort })}
                        disabled={!isShort}
                    >
                        Long
                    </Button>
                    <Button
                        onClick={toggleIsShort}
                        className={clsx('short', { active: isShort })}
                        disabled={isShort}
                    >
                        Short
                    </Button>
                </div>
                <div className='tab-buttons-container'>
                    <Button
                        variant='transparent'
                        onClick={() => setTradeType(ExchangeTradeTypes.MARKET)}
                        className={clsx('tab', {
                            active: tradeType === ExchangeTradeTypes.MARKET,
                        })}
                    >
                        Market
                    </Button>
                    <Button
                        variant='transparent'
                        onClick={() => setTradeType(ExchangeTradeTypes.LIMIT)}
                        className={clsx('tab', {
                            active: tradeType === ExchangeTradeTypes.LIMIT,
                        })}
                    >
                        Limit
                    </Button>
                </div>
                {renderTabs[tradeType]}
            </Card>
        </div>
    );
};

export default ExchangeSwap;
